import { render, staticRenderFns } from "./userTranscript.vue?vue&type=template&id=6d75be13&scoped=true&lang=html&"
import script from "./userTranscript.vue?vue&type=script&lang=ts&"
export * from "./userTranscript.vue?vue&type=script&lang=ts&"
import style0 from "./userTranscript.vue?vue&type=style&index=0&id=6d75be13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d75be13",
  null
  
)

export default component.exports